import { sendGAEvent } from '../utils';

export enum TrackingUserParamsEventEnum {
  empty_cookie_stag = 'empty_cookie_stag',
}

/**
 *
 * @param request_data - The query string passed to the /info/project endpoint.
 * @description This function sends a GA event when the /info/project endpoint does not set the `stag` cookie.
 * It uses the `gtag` function to send the event with the specified data.
 */
export const sendEmptyCookieStagEvent = (request_data: string) => {
  try {
    sendGAEvent(TrackingUserParamsEventEnum.empty_cookie_stag, {
      category: 'Error',
      request_data,
    });
    return;
  } catch (e) {
    console.error('Error sending empty cookie stag event:', e);
    return;
  }
};
